var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"products-table",attrs:{"data-testid":"products-table"}},[_c(_setup.DataTable,{attrs:{"data":_setup.tableData,"columns":_setup.columns,"has-interaction":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }